import React from "react";
import Marquee from "react-fast-marquee";
import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

import { partnersMarqueeData } from "../model/constants";

export const PartnersMarquee: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const isLarge = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Stack width={1} direction="column" gap={8}>
      <Typography
        width={1}
        variant="h4"
        color="textSecondary"
        textAlign="center"
        fontWeight={300}
        sx={{
          fontSize: {
            lg: "2.125rem",
            md: "2rem",
            sm: "1.5rem",
            xs: "1.2rem",
          },
        }}
      >
        {t("partners.title1")}{" "}
        <Typography
          component="span"
          fontWeight="inherit"
          variant="inherit"
          color="primary"
        >
          {t("partners.titleAccent1")}{" "}
        </Typography>
        {t("partners.title2")}{" "}
        <Typography
          component="span"
          fontWeight="inherit"
          variant="inherit"
          color="primary"
        >
          {t("partners.titleAccent2")}
        </Typography>
      </Typography>

      <Marquee
        style={{
          background: "transparent",
          padding: "12px 0",
          flexShrink: 0,
          overflowY: "hidden",
          maxHeight: "90px",
        }}
        gradient
        gradientColor="#000000"
        pauseOnHover
      >
        {partnersMarqueeData.map((data) => {
          return (
            <Box
              key={data.alt}
              component="img"
              src={data.image}
              alt={data.alt}
              height={isLarge ? 50 : 30}
              maxHeight={50}
              marginX={4}
              marginY={0}
              sx={{
                objectFit: "contain",
                mixBlendMode: "multiply",
              }}
            />
          );
        })}
      </Marquee>
    </Stack>
  );
};
